<template>
  <div class="footer-wrap">
    <div>Copyright © 2023 中共宁波市委人才工作领导小组办公室 版权所有</div>
    <div>工信部备案：浙ICP备05064032号-3</div>
  </div>
</template>

<script>
export default {
  name: 'GlobalFooter',
}
</script>

<style lang="less" scoped>
@media screen {
  .footer-wrap {
    height: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #2855f1;
    font-size: 14px;
    color: #ffffff;
    font-weight: 400;
    margin-top: 50px;
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
